import React, { useContext } from 'react';
import { MapWidgetNewsStore } from './store';

export const NewsContext = React.createContext<MapWidgetNewsStore | undefined>(
  undefined,
);

export const useNewsContext = (): MapWidgetNewsStore => {
  const value = useContext(NewsContext);

  if (value) return value;

  throw new Error(
    'Не удалось получить значение контекста NewsContext. Контекст не был инициализирован перед обращением',
  );
};
